<template>
  <div class="banner_logo_wrapper">
    <div class="banner_logo_bg">
      <img class="banner_logo" src="../../../static/img/首页banner_logo.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerLogo'
}
</script>

<style lang="scss" scoped>
.banner_logo_wrapper {
  position: absolute;
  bottom: -6px;
  left: 63.65%;
  right: 20.63%;
  height: 8rem;
  z-index: 10;
  pointer-events: none;
  max-width: 30rem;
}

.banner_logo_bg {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../../static/img/首页banner_logo_bg.png") no-repeat center bottom;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
}

.banner_logo {
  width: 4rem;
  height: auto;
  object-fit: contain;
  margin-top: 1.53%;
  position: absolute;
  top: 2rem;
}

@media screen and (max-width: 1200px) {
  .banner_logo_wrapper {
    height: 5rem;
  }

  .banner_logo {
    width: 2.5rem;
  }
}
@media screen and (max-width: 768px) {
  .banner_logo_wrapper {
    height: 9rem;
    width: 14rem;
  }

  .banner_logo {
    width: 2rem;
    top: 6rem;
  }
}
</style>
